<template>
  <el-card>
    <div class="title">Daily report</div>
    <el-row class="search">
      <el-date-picker v-model="search.date" type="daterange" value-format="yyyy-MM-dd"
        :picker-options="retainedOptions" />
      <el-input style="width:180px" v-model="hostessId" placeholder="Please enter hostessId"></el-input>
      <el-button type="primary" @click="query()" :loading="loading">Search</el-button>
    </el-row>
    <el-row>
      <el-table :data="list" style="width: 100%" v-loading="loading" stripe border element-loading-text="loading"
        element-loading-spinner="el-icon-loading">
        <el-table-column prop="date" label="Date"></el-table-column>
        <!-- <el-table-column prop="agentId" label="Agency ID"></el-table-column> -->
        <el-table-column prop="hostessId" label="Hostess ID"></el-table-column>
        <el-table-column prop="hostessNickname" label="Name"></el-table-column>
        <!-- <el-table-column
          prop="hostessLevel"
          label="Quality level"
        ></el-table-column> -->
        <el-table-column prop="hostessOnlineTime" label="Online duration"></el-table-column>
        <el-table-column prop="hostessLiveTime" label="Live duration"></el-table-column>
        <el-table-column prop="activeCallSuccessRate" label="Success Rate"></el-table-column>
        <el-table-column prop="totalCallCount" label="Total Call Duration"></el-table-column>
        <el-table-column prop="lastLogin" label="lastLogin"></el-table-column>
        <el-table-column prop="passOrNot" label="passOrNot"></el-table-column>
        <el-table-column prop="registerTime" label="registerTime"></el-table-column>
        <!-- <el-table-column
          prop="revenueForcast"
          label="Revenue estimate(USD)"
        ></el-table-column> -->
        <!-- <el-table-column
          prop="activeCallRate"
          label="activeCallRate"
        ></el-table-column>
        <el-table-column
          prop="activeExposeCount"
          label="activeExposeCount"
        ></el-table-column> -->
      </el-table>
    </el-row>
    <el-row class="user-options">
      <el-pagination :current-page.sync="page" layout="total, prev, pager, next" background
        @current-change="handleCurrentChange" :total="total" class="pagination" :page-size="10"></el-pagination>
    </el-row>
  </el-card>
</template>

<script>
import { getDailyReport } from '@/api/dashboard.js'
import { datainfor } from '@/utils/formdata.js'
export default {
  data() {
    return {
      loading: false,
      list: [],
      page: 1,
      total: 0,
      hostessId: '',
      retainedOptions: {
        disabledDate(time) {
          return time.getTime() >= Date.now() - 86400000
        }
      },
      search: {
        date: [datainfor(1), datainfor(1)]
      }
    }
  },
  created() {
    this.query()
  },
  methods: {
    // 获取列表
    async query() {
      const { data: res } = await getDailyReport({
        startTime: this.search.date[0],
        endTime: this.search.date[1],
        hostessId: Number(this.hostessId),
        page: this.page
      })
      if (res.code !== 0)
        return this.$message({
          message: res.msg,
          center: true,
          type: 'error'
        })
      this.$message({
        message: res.msg,
        center: true,
        type: 'success'
      })
      this.list = res.data.data
      this.total = res.data.total
    },
    // 分页
    handleCurrentChange() {
      this.query()
    }
  }
}
</script>
